// Detect embed kind + return a player URL for inline reproduction.
// Supports: YouTube, Vimeo, raw video URLs (mp4/webm/ogg).

export function detectVideoEmbed(url) {
  if (!url || typeof url !== "string") return null;
  const trimmed = url.trim();

  // YouTube: youtube.com/watch?v=ID, youtu.be/ID, youtube.com/shorts/ID, embed/ID
  const ytPatterns = [
    /(?:youtube\.com\/watch\?(?:.*&)?v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/shorts\/)([A-Za-z0-9_-]{11})/,
  ];
  for (const re of ytPatterns) {
    const m = trimmed.match(re);
    if (m) {
      return {
        kind: "youtube",
        id: m[1],
        embedUrl: `https://www.youtube.com/embed/${m[1]}?rel=0&modestbranding=1`,
      };
    }
  }

  // Vimeo: vimeo.com/ID or player.vimeo.com/video/ID
  const vimeoMatch = trimmed.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vimeoMatch) {
    return {
      kind: "vimeo",
      id: vimeoMatch[1],
      embedUrl: `https://player.vimeo.com/video/${vimeoMatch[1]}`,
    };
  }

  // Raw video file (URL ends in mp4/webm/ogg/mov)
  if (/\.(mp4|webm|ogg|ogv|mov|m4v)(\?.*)?$/i.test(trimmed)) {
    return { kind: "video", embedUrl: trimmed };
  }

  // Drive share link (file/d/ID/view) → preview
  const driveMatch = trimmed.match(/drive\.google\.com\/file\/d\/([A-Za-z0-9_-]+)/);
  if (driveMatch) {
    return {
      kind: "drive",
      id: driveMatch[1],
      embedUrl: `https://drive.google.com/file/d/${driveMatch[1]}/preview`,
    };
  }

  return null; // unknown — caller should open in new tab
}

export const isVideoMime = (mime) => typeof mime === "string" && mime.toLowerCase().startsWith("video/");
